var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWriteObs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4161 10.854C10.7385 10.854 11 11.1106 11 11.427C11 11.7434 10.7385 12 10.4161 12H0.583906C0.26149 12 0 11.7434 0 11.427C0 11.1106 0.26149 10.854 0.583906 10.854H10.4161Z",
    fill: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.03628 0.570951C7.81079 -0.190091 9.06755 -0.190347 9.84239 0.570362L10.4191 1.13628C11.1932 1.89634 11.1932 3.12867 10.4191 3.88873L4.58123 9.62034C4.20928 9.98549 3.70491 10.191 3.17878 10.191H1.19842C0.876002 10.191 0.614512 9.93437 0.614512 9.61799V7.68645C0.614532 7.17067 0.823407 6.67576 1.19482 6.31081L7.03628 0.570951ZM1.78232 9.045H3.17878C3.39508 9.04499 3.6025 8.96075 3.75548 8.81063L9.59334 3.07842C9.91176 2.76575 9.91177 2.25925 9.59334 1.94659L9.01664 1.38008C8.69794 1.0673 8.18115 1.06768 7.86263 1.38067L2.02057 7.12053C1.86784 7.27063 1.78234 7.47428 1.78232 7.68645V9.045Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWriteObs);
export default __webpack_public_path__ + "static/media/WriteObs.87e7f0e0d11a910eed03a323f6aa6b47.svg";
export { ForwardRef as ReactComponent };